import { useRoot } from "./context/root-context";
import "./App.scss";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import ErrorComponent from "./components/msal/ErrorComponent";
import RootLayout from "./Layout";
import LandingPage from "./pages/landing/landing-page";

function App() {
  const { contentQARootRef } = useRoot();
  const authRequest = {
    scopes: ["User.Read"],
  };
  return (
    <RootLayout>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={authRequest}
        errorComponent={ErrorComponent}
        // loadingComponent={LoadingComponent}
      >
        <div ref={contentQARootRef} className="app_root_css">
          <LandingPage />
        </div>
      </MsalAuthenticationTemplate>
    </RootLayout>
  );
}

export default App;
